import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Collapse from 'react-bootstrap/lib/Collapse';

import ItemWrapper from './ItemWrapper';
import Title from './Title';
import RadioBtn from './RadioBtn';
import {formatPrice} from 'lib/helpers/globalize-helper';

const getNoOfStopsLabel = (num, translations) => {
  if (num > 1) {
    return translations.moreThanOneStops.replace('numberStops', num);
  }

  return (num === 0) ? translations.Direct : translations.oneStop;
};

class Stops extends Component {
  state = {
    show: true
  };

  toggleFilter = () => this.setState((prevState) => ({show: !prevState.show}));

  render() {
    const {show} = this.state;
    const {stops, selectStopsValue, currency, translations} = this.props;
    const {
      from, stops: stopsTr
    } = translations;
    return (
      <ItemWrapper>
        <Title
          title={stopsTr.stops}
          isOpen={show}
          onClick={this.toggleFilter}
        />
        <Collapse in={show}>
          <div className="filter-content">
            {
              stops.options.map(({count, price}) => (
                <RadioBtn
                  key={count}
                  name="react-stops-filter"
                  label={getNoOfStopsLabel(count, translations)}
                  option={count}
                  value={stops.value !== null ? stops.value : stops.defaultValue}
                  onChange={selectStopsValue}
                >
                  <small className="float-right text-muted">
                    {from}&nbsp;{formatPrice(price, currency)}
                  </small>
                </RadioBtn>
              ))
            }
          </div>
        </Collapse>
      </ItemWrapper>
    );
  }
}

Stops.propTypes = {
  currency: PropTypes.string.isRequired,
  stops: PropTypes.shape({
    defaultValue: PropTypes.number.isRequired,
    value: PropTypes.number,
    options: PropTypes.object.isRequired
  }),
  selectStopsValue: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    from: PropTypes.string.isRequired,
    stops: PropTypes.object.isRequired,
    priceRange: PropTypes.string.isRequired,
    maxPrice: PropTypes.string.isRequired,
    reset: PropTypes.string.isRequired
  })
};

export default Stops;
